var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessToastIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "#188F24"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "#65A30D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7961 9.41006L17.0461 8.28506C17.0156 8.27998 16.9844 8.27998 16.9539 8.28506L10.2039 9.41006C10.1382 9.42098 10.0785 9.45484 10.0355 9.50561C9.99243 9.55639 9.96878 9.6208 9.96875 9.68737V18.1249C9.96875 20.2905 11.1781 22.2902 13.4624 23.9091C14.5268 24.6584 15.6867 25.2621 16.9111 25.704C16.9688 25.7235 17.0312 25.7235 17.0889 25.704C18.3133 25.2621 19.4732 24.6584 20.5376 23.9091C22.8219 22.2902 24.0312 20.2905 24.0312 18.1249V9.68737C24.0312 9.6208 24.0076 9.55639 23.9645 9.50561C23.9215 9.45484 23.8618 9.42098 23.7961 9.41006ZM16.188 19.7958L13.1109 16.7186L13.9062 15.9232L16.1245 18.1415L20.5963 12.9254L21.4505 13.6567L16.188 19.7958Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessToastIcon);
export default __webpack_public_path__ + "static/media/success-toast-icon.980f4e0f1dfc0f6cbdded3789edeff64.svg";
export { ForwardRef as ReactComponent };